import React from 'react';
import "./Box.scss";

export default function Box(props) {
  let className = "grapheme-box";
  if (props.className) className += ` ${props.className}`;

  return (
    <div className={className} style={props.style}>
      {props.children}
    </div>
  );
}
